<style lang="scss" scoped>
.text-pre {
  white-space: pre;
}

.close-button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}

.transaction-image-wrapper {
  overflow-x: auto;
}

.advice-text {
  margin-top: 40px;
}

@media (min-width: 1200px) {
  .close-button {
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
  }
}
</style>

<template>
  <modal
    name="prepaid"
    :maxWidth="1200"
    width="100%"
    height="auto"
    :scrollable="true"
    :adaptive="true"
    style="overflow-x: hidden"
    @before-open="beforeOpen"
  >
    <div class="card">
      <div class="card-body position-relative">
        <button
          type="button"
          class="btn close-button"
          @click="$modal.hide('prepaid')"
        >
          <i class="fas fa-times"></i>
        </button>
        <div class="row advice-text">
          <div class="col-4">
            Senden Sie eine Überweisung an:
            <p class="text-pre">
              {{ prepaidTo }}
              {{ prepaidIban }}
              BIC: {{ prepaidBic }} Verwendungszweck:
              {{ transferDescription }} Betrag: {{ priceString }}
            </p>
          </div>
          <div class="col-8">
            Bitte beachten:<br /><br />
            <ul>
              <li>Überweisungen dauern i.d.R. 1 - 3 Werktage (Mo-Fr)</li>
              <li>Verwendungszweck muss immer korrekt angegebenen weden</li>
              <li>
                Du erhälst per E-Mail weitere Anweisungen - schaue auch im
                Spam-Ordner nach
              </li>
            </ul>
          </div>
        </div>
        <p class="text-pre transaction-image-wrapper">
          <img id="prepaid-image" :src="transactionFormUrl" />
        </p>
        <button class="btn btn-primary text-xl" @click="print">
          <i class="fas fa-print"></i>
          Ausdrucken
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { formatCurrency } from "@/js/currency";

export default {
  data() {
    return {
      priceString: null,
      transferDescription: "",
      transactionFormUrl: ""
    };
  },
  computed: {
    prepaidTo() {
      return Laravel.payment.prepaid.to;
    },
    prepaidIban() {
      let rawIban = Laravel.payment.prepaid.iban;
      let formattedIban = "";
      for (let i = 0, n = rawIban.length; i < n; i += 4) {
        formattedIban += rawIban.substr(i, 4) + " ";
      }
      return formattedIban;
    },
    prepaidBic() {
      return Laravel.payment.prepaid.bic;
    }
  },
  methods: {
    beforeOpen(event) {
      this.priceString = formatCurrency(event.params.price);
      let transactionId = event.params.transactionId;
      this.transactionFormUrl = `/api/v1/transaction/prepaid/${transactionId}/form`;
      this.transferDescription = event.params.transferDescription;
    },
    print() {
      let win = window.open("");
      let isFirefox = navigator.userAgent.indexOf("Firefox") != -1;
      win.document.write(
        '<img src="' +
          this.transactionFormUrl +
          (isFirefox
            ? '" />'
            : '" onload="window.focus();window.print();window.close();" />')
      );
      if (isFirefox) {
        win.focus();
        win.print();
        win.close();
      }
    }
  }
};
</script>
